/**
 * Router de secciones del dashboard.
 * Cada sección es un módulo que exporta render(root, ctx).
 */
import { renderInicio } from './inicio.js';
import { renderPatrimonio } from './patrimonio.js';
import { renderInmuebles } from './inmuebles.js';
import { renderGastos } from './gastos.js';
import { renderAutosell } from './autosell.js';
import { renderProyectos } from './proyectos.js';
import { renderTareas } from './tareas.js';
import { renderNotas } from './notas.js';
import { renderSalud } from './salud.js';
import { renderChat } from './chat.js';
import { renderArchivos } from './archivos.js';
import { renderDescubrir } from './descubrir.js';
import { renderAjustes } from './ajustes.js';
import { renderSistema, renderOrquestadorPanel } from './sistema.js';
import { renderMaestro } from './maestro.js';
import { renderActividadAgentes } from './actividad-agentes.js';
import { renderInteligencia } from './inteligencia.js';
import { renderTrading } from './trading.js';
import { renderYouTube } from './youtube.js';
import { renderPrompts } from './prompts.js';
import { renderAgency } from './agency.js';
import { renderMetaAds } from './meta-ads.js';
import { renderBodega } from './bodega.js';
import { renderEquipo } from './equipo.js';
import { renderInversiones } from './inversiones.js';
import { renderRenovatech } from './renovatech.js';
import { renderCochesSuiza } from './coches-suiza.js';

const SECTIONS = {
  inicio: renderInicio,
  patrimonio: renderPatrimonio,
  inmuebles: renderInmuebles,
  gastos: renderGastos,
  autosell: renderAutosell,
  bodega: renderBodega,
  proyectos: renderProyectos,
  tareas: renderTareas,
  notas: renderNotas,
  salud: renderSalud,
  chat: renderChat,
  archivos: renderArchivos,
  descubrir: renderDescubrir,
  ajustes: renderAjustes,
  sistema: renderSistema,
  orquestador: renderOrquestadorPanel,
  maestro: renderMaestro,
  actividad: renderActividadAgentes,
  inteligencia: renderInteligencia,
  trading: renderTrading,
  youtube: renderYouTube,
  prompts: renderPrompts,
  agency: renderAgency,
  'meta-ads': renderMetaAds,
  equipo: renderEquipo,
  inversiones: renderInversiones,
  renovatech: renderRenovatech,
  'coches-suiza': renderCochesSuiza,
};

export function renderSection(name, root, ctx) {
  const fn = SECTIONS[name] || renderInicio;
  root.innerHTML = '';
  fn(root, ctx);
}
